import { render, staticRenderFns } from "./ProviderRoleManagement.vue?vue&type=template&id=ba14668c&scoped=true&"
import script from "./ProviderRoleManagement.vue?vue&type=script&lang=js&"
export * from "./ProviderRoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProviderRoleManagement.vue?vue&type=style&index=0&id=ba14668c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba14668c",
  null
  
)

export default component.exports